import React from 'react';

import * as styles from './listing-page-button-toggle.scss';

interface ListingPageButtonToggleOption {
  label: string;
  value: string;
}

interface ListingPageButtonToggleProps {
  label: string;
  options: ListingPageButtonToggleOption[];
  selectedValue: string;
  onChange: (value: string) => void;
}

export const ListingPageButtonToggle = ({ label, options, selectedValue, onChange }: ListingPageButtonToggleProps) => {
  return (
    <div className={styles.buttonToggle}>
      <div className={styles.label}>{label}</div>
      <div className={styles.toggleGroup} role="group" aria-label={label}>
        {options.map(option => {
          const isActive = option.value === selectedValue;
          return (
            <button
              key={option.value}
              type="button"
              aria-pressed={isActive}
              className={`${styles.toggleButton} ${isActive ? styles.toggleButtonActive : ''}`}
              onClick={() => {
                if (!isActive) {
                  onChange(option.value);
                }
              }}
            >
              {option.label}
            </button>
          );
        })}
      </div>
    </div>
  );
};
